import './sprite.svg';
import './vendor/jquery.magnific-popup.min';
import './vendor/slick.min';
import './vendor/tooltip';
import './vendor/jquery.mCustomScrollbar.min';
import './vendor/stickyfill';
import './vendor/ion.rangeSlider.min';
import './vendor/jquery.maskedinput.min';
import './vendor/jquery.validate.min';
import './app';
import './collapse';
import './transition';
import './contacts';
import './infrastructure';
import './news';
import './favorites';
import './components/Gallery/Gallery';
import Cookies from './cookies';

$(function () {


    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 60) {
            $(".header").addClass("isScroll");
            $('.swipe').fadeOut();
        } else {
            $(".header").removeClass("isScroll");
        }
    });

    $("[data-youtube]").on("click", function(e) {
        e.preventDefault();
        var youtubeCode = $(this).data("youtube"),
            playerId = $(this).attr("id");

        if (!playerId) {
            playerId = "youtube_video_" + Math.random().toString(36).substr(2, 5);
            $(this).attr("id", playerId);
        }

        new YT.Player(playerId, {
            videoId: youtubeCode,
            events: {
                onReady: function(event) {
                    var target = event.target;
                    target.id = playerId;
                    event.target.playVideo();
                }
            }
        });
        setTimeout(function() {
            $(window).trigger("resize");
        }, 0);
        return false;
    });

    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover focus',
        template: '<div class="tooltip tooltip-new" role="tooltip" style="position: absolute;"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title : 'Уточните цену в офисе',
        placement: 'top',
        html: true,
        delay: { show: 100, hide: 200 }
    });

    window.initSliderDefault('.js-slider-default');

    window.initSliderFirst('.js-slider-first');

    window.initSliderBlocks('.js-block-slider');

    window.initSliderPreviews('.js-slider-with-prev');
});


window.initSliderDefault = function (slider) {
    $(slider).each(function () {
        if (!$(this).hasClass('slick-slider')) {
            var autoPlayDelay = $(this).data('autoplay'),
                currentSlider = $(this);
            if ( !autoPlayDelay || autoPlayDelay == '' ) {
                autoPlayDelay = 5000;
            }
            $(this)
                .on('init', function (event, slick) {
                    initProgress(currentSlider,autoPlayDelay);
                })
                .slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    pauseOnHover: false,
                    autoplay: true,
                    autoplaySpeed: parseInt(autoPlayDelay),
                    arrows: false,
                    dots: true
                })
                .on('beforeChange', function (slick) {
                    clearInterval(currentSlider.progress);
                    currentSlider.find('.slick-active').find('.slick-progress').detach();
                })
                .on('afterChange', function (event, slick, currentSlide) {
                    initProgress(currentSlider,autoPlayDelay);
                })
            ;
        }
    });

    function initProgress(currentSlider,autoPlayDelay) {
        currentSlider.find('.slick-active').append('<svg class="slick-progress" width="20" height="20" viewBox="0 0 22 22">' +
            '<circle class="slick-progress-line" cx="11" cy="11" r="9" stroke-width="1" stroke-dasharray="" stroke-dashoffset="" fill="none"></circle>' +
            '</svg>');

        var timeUpdate = parseInt(autoPlayDelay) / 100,
            PercentProgress = 0;

        currentSlider.progress = setInterval(function () {
            PercentProgress += 1;
            moveProgress(currentSlider.find('.slick-active'),PercentProgress);
        },timeUpdate);
    }

    function moveProgress(box,procent) {
        var progress = box.find('.slick-progress'),
            circleWidth = 2 * Math.PI * 9,
            oneProcent = circleWidth / 100;
        progress.find('.slick-progress-line')
            .css({
                'stroke-dashoffset': -oneProcent * procent,
                'stroke-dasharray': circleWidth
            })
        ;
    }

};
window.initSliderFirst = function (slider) {
    $(slider).each(function () {
        var autoPlayDelay = $(this).data('autoplay'),
            currentSlider = $(this);
        if ( !autoPlayDelay || autoPlayDelay == '' ) {
            autoPlayDelay = 5000;
        }
        $(this)
            .on('init', function (event, slick) {
                //var slideDOM = slick.$slides[0];
                initProgress(currentSlider,autoPlayDelay);
            })
            .slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnHover: false,
                autoplay: true,
                autoplaySpeed: parseInt(autoPlayDelay),
                arrows: false,
                dots: true
            })
            .on('beforeChange', function (slick) {
                clearInterval(currentSlider.progress);
                currentSlider.find('.slick-active').find('.slick-progress').detach();
            })
            .on('afterChange', function (event, slick, currentSlide) {
                //var slideDOM = slick.$slides[currentSlide];
                initProgress(currentSlider,autoPlayDelay);
            })
        ;

    });

    function initProgress(currentSlider,autoPlayDelay) {
        currentSlider.find('.slick-active').append('<svg class="slick-progress" width="20" height="20" viewBox="0 0 22 22">' +
            '<circle class="slick-progress-line" cx="11" cy="11" r="9" stroke-width="1" stroke-dasharray="" stroke-dashoffset="" fill="none"></circle>' +
            '</svg>');

        var timeUpdate = parseInt(autoPlayDelay) / 100,
            PercentProgress = 0;

        currentSlider.progress = setInterval(function () {
            PercentProgress += 1;
            moveProgress(currentSlider.find('.slick-active'),PercentProgress);
        },timeUpdate);
    }

    function moveProgress(box,procent) {
        var progress = box.find('.slick-progress'),
            circleWidth = 2 * Math.PI * 9,
            oneProcent = circleWidth / 100;
        progress.find('.slick-progress-line')
            .css({
                'stroke-dashoffset': -oneProcent * procent,
                'stroke-dasharray': circleWidth
            })
        ;
    }

};
window.initSliderBlocks = function (slider) {
    $(slider).each(function () {

        if ($(window).width() < 760) {
            for (var i = 0; i < $('.news-item').length; i++) {
                if (i % 3 === 0) {
                    $('.news-list__in > .news-item:lt(3)').wrapAll('<div class="group"></div>');
                }
            }
        }

        var autoPlayDelay = $(this).data('autoplay'),
            currentSlider = $(this);
        if ( !autoPlayDelay || autoPlayDelay == '' ) {
            autoPlayDelay = 5000;
        }
        $(this)
            .on('init', function () {
                initProgress(currentSlider,autoPlayDelay);
            })
            .slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                pauseOnHover: false,
                autoplay: true,
                autoplaySpeed: parseInt(autoPlayDelay),
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            })
            .on('beforeChange', function () {
                clearInterval(currentSlider.progress);
                currentSlider.find('.slick-active').find('.slick-progress').detach();
            })
            .on('afterChange', function () {
                initProgress(currentSlider,autoPlayDelay);
            })
        ;

    });

    function initProgress(currentSlider,autoPlayDelay) {
        currentSlider.find('.slick-active').append('<svg class="slick-progress" width="20" height="20" viewBox="0 0 22 22">' +
            '<circle class="slick-progress-line" cx="11" cy="11" r="9" stroke-width="1" stroke-dasharray="" stroke-dashoffset="" fill="none"></circle>' +
            '</svg>');

        var timeUpdate = parseInt(autoPlayDelay) / 100,
            PercentProgress = 0;

        currentSlider.progress = setInterval(function () {
            PercentProgress += 1;
            moveProgress(currentSlider.find('.slick-active'),PercentProgress);
        },timeUpdate);
    }

    function moveProgress(box,procent) {
        var progress = box.find('.slick-progress'),
            circleWidth = 2 * Math.PI * 9,
            oneProcent = circleWidth / 100;
        progress.find('.slick-progress-line')
            .css({
                'stroke-dashoffset': -oneProcent * procent,
                'stroke-dasharray': circleWidth
            })
        ;
    }

};
window.initSliderPreviews = function (slider) {
    $(slider).each(function () {
        var autoPlayDelay = $(this).data('autoplay'),
            currentSlider = $(this);
        if ( !autoPlayDelay || autoPlayDelay == '' ) {
            autoPlayDelay = 5000;
        }
        var slider = $(this)
            .on('init', function (event, slick) {
                //var slideDOM = slick.$slides[0];
                initProgress(currentSlider,autoPlayDelay);
                changeThumbnails(0);
                changeText(0,slick);
            })
            .slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnHover: false,
                autoplay: true,
                autoplaySpeed: parseInt(autoPlayDelay),
                arrows: false,
                dots: true
            })
            .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                clearInterval(currentSlider.progress);
                currentSlider.find('.slick-active').find('.slick-progress').detach();
            })
            .on('afterChange', function (event, slick, currentSlide) {
                changeThumbnails(currentSlide);
                changeText(currentSlide,slick);
            })
            .on('afterChange', function (event, slick, currentSlide) {
                //var slideDOM = slick.$slides[currentSlide];
                initProgress(currentSlider,autoPlayDelay);
            })
        ;

        $(document).on('click', '.js-preview-slide', function (e) {
            e.preventDefault();
            handlerThumbClick($(this),slider);
        });
    });

    function handlerThumbClick(thumb,slider) {
        var targetSlide = Number(thumb.attr('href'));

        slider.slick('slickGoTo', targetSlide);
    }

    function changeThumbnails(slide) {
        var thumbBox = $('.js-preview-thumbs'),
            thumb = thumbBox.find('.js-preview-slide');

        thumb.removeClass('active');
        thumb.eq(slide).addClass('active');
    }

    function changeText(slide,slider) {
        var textBox = $('.js-preview-text'),
            currentSlideObject = $(slider.$slides[slide]).find('.js-slider-slide'),
            currentText = currentSlideObject.data('text');

        textBox.html(currentText);
    }

    function initProgress(currentSlider,autoPlayDelay) {
        currentSlider.find('.slick-active').append('<svg class="slick-progress" width="20" height="20" viewBox="0 0 22 22">' +
            '<circle class="slick-progress-line" cx="11" cy="11" r="9" stroke-width="1" stroke-dasharray="" stroke-dashoffset="" fill="none"></circle>' +
            '</svg>');

        var timeUpdate = parseInt(autoPlayDelay) / 100,
            PercentProgress = 0;

        currentSlider.progress = setInterval(function () {
            PercentProgress += 1;
            moveProgress(currentSlider.find('.slick-active'),PercentProgress);
        },timeUpdate);
    }

    function moveProgress(box,procent) {
        var progress = box.find('.slick-progress'),
            circleWidth = 2 * Math.PI * 9,
            oneProcent = circleWidth / 100;
        progress.find('.slick-progress-line')
            .css({
                'stroke-dashoffset': -oneProcent * procent,
                'stroke-dasharray': circleWidth
            })
        ;
    }

};

//$('.sidebar__in').Stickyfill();

var mfp = $.magnificPopup.instance;

window.POPUP = {
    openAjax: function (target) {
        mfp.open({
            type: 'ajax',
            mainClass: 'mfp-fade ajax-popup',
            items: {
                src: target
            },
            preloader: false,
            showCloseBtn: false,
            fixedBgPos: true,
            fixedContentPos: true,
            callbacks: {
                open: function () {
                    $('<button type="button" class="mfp-close ic-close"></button>').appendTo('.mfp-content');
                }
            }
        }, 0);
    },
    openStatic: function (data) {
        mfp.open({
            type: 'inline',
            mainClass: 'mfp-fade ajax-static',
            items: {
                src: $(data)
            },
            preloader: false,
            showCloseBtn: false,
            closeOnBgClick: false,
            fixedBgPos: true,
            fixedContentPos: true,
            callbacks: {
                open: function () {
                    $('<button type="button" class="mfp-close ic-close"></button>').appendTo('.mfp-container');
                    $('textarea.form__input').autoResize({
                        animate: false,
                        extraSpace: 0,
                        limit: 1000
                    });
                    $('.phone-input').mask("+7 (999) 999 99 99");
                }
            }
        }, 0);
    },
    webcamVideo: function (data) {
        mfp.open({
            type: 'iframe',
            mainClass: 'mfp-fade vebcam-popup-holder',
            items: {
                src: data
            },
            preloader: false,
            showCloseBtn: false,
            closeOnBgClick: false,
            fixedBgPos: true,
            fixedContentPos: true,
            callbacks: {
                open: function () {
                    $('<button type="button" class="mfp-close ic-close"></button>').appendTo('.mfp-container');

                }
            }
        }, 0);
    },
    openImage: function (url, number) {
        $.ajax({
            type: "POST",
            url: url,
            dataType: 'json',
            data: '',
            success: function (images) {
                openGallery(images);
            }
        });

        function setGalleryList(items) {
            var listItems = items,
                listLenght = listItems.length;


            $('<div class="mfp-gallery-list"></div>').appendTo('.mfp-container');

            for (var i = 0; i < listLenght; i++) {
                $('<a href="' + i + '" class="mfp-gallery-list__item"><img src="' + listItems[i].thumbnail + '" /></a>').appendTo('.mfp-gallery-list');
            }

            $('.mfp-gallery-list__item').eq(0).addClass('current');

            if (listLenght > 5) {
                $('.mfp-gallery-list').slick({
                    infinite: true,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    centerMode: true,
                    prevArrow: '<button class="slider-arrow slider-arrow__left ic-slider-arrow-left mfp-prevent-close" aria-label="Previous" type="button"></button>',
                    nextArrow: '<button class="slider-arrow slider-arrow__right ic-slider-arrow-right mfp-prevent-close" aria-label="Next" type="button"></button>'
                });
            }

        }

        function setActiveThumbnail(index) {
            $('.mfp-gallery-list__item').removeClass('current');
            $('.mfp-gallery-list__item[href="' + index + '"]').addClass('current');

            if ($('.mfp-gallery-list').is('.slick-initialized')) {
                $('.mfp-gallery-list').slick('slickGoTo', index);
            }
        }

        function openGallery(images) {

            mfp.open({
                type: 'image',
                preloader: false,
                showCloseBtn: false,
                fixedBgPos: true,
                fixedContentPos: true,
                closeOnBgClick: false,
                mainClass: 'mfp-image-holder mfp-no-margins',
                items: images.full,
                image: {
                    verticalFit: true
                },
                gallery: {
                    enabled: true,
                    preload: 0,
                    navigateByImgClick: false,
                    arrowMarkup: '<button type="button" class="slider-arrow slider-arrow__%dir% ic-slider-arrow-%dir%"></button>'
                },
                callbacks: {
                    open: function () {
                        setGalleryList(images.mini);
                        $('<button type="button" class="mfp-close ic-close"></button>').appendTo('.mfp-content');
                        if (!isNaN(number)) {
                            mfp.goTo(number);
                        }
                    },
                    change: function () {
                        setActiveThumbnail(this.index);
                    },
                    markupParse: function (template, values, item) {
                        setActiveThumbnail(item.index);
                        setTimeout(function () {
                            $('.mfp-content').css({
                                'background-image': 'url(' + item.src + ')'
                            });
                        }, 0);
                    }
                }
            }, 0);
        }
    },
    openVideo: function (video, type) {
        getVideoType(video, type);

        function getVideoType(video, type) {
            if (type == 'local') {

                mfp.open({
                    type: 'inline',
                    mainClass: 'mfp-fade video-popup-holder',
                    items: {
                        src: '<div class="loader-window"><div class="loader-window__progress"></div></div>'
                    },
                    preloader: false,
                    showCloseBtn: false,
                    fixedBgPos: true,
                    fixedContentPos: true,
                    callbacks: {
                        open: function () {
                            $('<button type="button" class="mfp-close ic-close"></button>').appendTo('.mfp-content');
                            initVideo(video);
                        },
                        close: function () {
                            clearInterval(window.videoProgress);
                        }
                    }
                }, 0);

            } else if (type == 'youtube') {

                mfp.open({
                    type: 'inline',
                    mainClass: 'mfp-fade video-popup-holder',
                    items: {
                        src: '<div class="loader-window"><div class="loader-window__progress"></div></div>'
                    },
                    preloader: false,
                    showCloseBtn: false,
                    fixedBgPos: true,
                    fixedContentPos: true,
                    callbacks: {
                        open: function () {
                            $('.mfp-content').attr('id', 'playerY');
                            $('<button type="button" class="mfp-close ic-close"></button>').appendTo('.mfp-container');
                            initYoutube(video, 'playerY');
                        }
                    }
                }, 0);

            }
        }

        function initYoutube(videoUrl, playerId) {
            var player = new YT.Player(playerId, {
                videoId: videoUrl,
                playerVars: {
                    'autoplay': 1,
                    'controls': 1,
                    'disablekb': 1,
                    'modestbranding': 0,
                    'loop': 1,
                    'rel': 0,
                    'fs': 0,
                    'start': 0,
                    'showinfo': 0,
                    'enablejsapi': 1
                },
                events: {
                    'onReady': function (event) {
                        event.target.setVolume(50);
                    },
                    'onStateChange': function (event) {
                        if (event.data == YT.PlayerState.PAUSED) {

                        } else {

                        }
                    },
                    'onError': function (event) {
                        console.log(arguments);
                    }
                }
            });
        }

        function initVideo(videoUrl) {
            var content = '<video class="mfp-player-item mfp-prevent-close" id="playerFullPage" autoplay><source src="' + videoUrl + '" type="video/mp4"></video>' +
                '<div class="video-control mfp-prevent-close">' +
                '<div class="video-control__timeline mfp-prevent-close"><div class="video-control__progress mfp-prevent-close"></div></div>' +
                '</div>';

            $(content).appendTo('.mfp-content');

            window.mediaPlayer = $('#playerFullPage');

            document.getElementById('playerFullPage').onloadeddata = function () {
                $('.loader-window').detach();
            };

            window.mediaPlayer.controls = true;

            window.videoProgress = setInterval(function () {
                var totalTime = window.mediaPlayer[0].duration,
                    currentTime = window.mediaPlayer[0].currentTime,
                    percentage = 100 / totalTime * currentTime;

                $('.video-control__progress').css({
                    'width': percentage + '%'
                });
            }, 100);
        }

    },
    imageSingle: function (url) {
        mfp.open({
            type: 'image',
            preloader: false,
            showCloseBtn: false,
            fixedBgPos: true,
            fixedContentPos: true,
            closeOnBgClick: false,
            mainClass: 'mfp-image-holder mfp-no-margins',
            items: url,
            image: {
                verticalFit: true
            },
            callbacks: {
                open: function () {
                    $('<button type="button" class="mfp-close ic-close"></button>').appendTo('.mfp-content');
                    $('.mfp-content').css({
                        'background-image': 'url(' + url + ')'
                    });
                }
            }
        }, 0);
    },
    close: function () {
        mfp.close();
    }
};

function openCallback(btn) {
    var callbackformAPI = btn.attr('data-form-api');

    var popupTemplate = "<div class='modal js-modal' id='callback'> " +
        "<button class='modal-close'> " +
        "<svg class='modal-close__icon'><use xlink:href='#spr-close'></use></svg> " +
        "</button> " +
        "<div class='modal-body'> " +
        "<h2 class='modal-title'>ОБРАТНЫЙ ЗВОНОК</h2>" +
        "<p class='modal-text'>Пожалуйста, заполните все поля</p> " +
        "<form action='' class='callback-form' id='callback-form'> " +
        "<div class='form-group'> " +
        "<div class='form-group__item'> " +
        "<label class='control-label' for='phone'>номер телефона</label>" +
        "<input class='form-control' type='tel' id='personal-phone' name='phone' value='' autocomplete='off' placeholder='' required> " +
        "</div> " +
        "<div class='form-group__item'> " +
        "<label class='control-label' for='name'>ВАШЕ ИМЯ</label> " +
        "<input class='form-control' type='text' id='name' name='name' value='' autocomplete='off' placeholder='' required > " +
        "</div> " +
        "</div> " +
        "<label class='callback-form__note'>Отправляя данную заявку, вы даете <a href='' class='gold-link'>согласие на обработку персональных данных</a></label>" +
        "<button type='submit' class='btn btn-default'>Заказать звонок</button> " +
        "</form> " +
        "</div>" +
        "</div> " +
        "<div class='modal modal--success js-modal' id='callback-success'> " +
        "<button class='modal-close'> " +
        "<svg class='modal-close__icon'><use xlink:href='#spr-close'></use></svg> " +
        "</button> " +
        "<div class='modal-body'> " +
        "<p class='modal-text-success'>Ваше сообщение принято</p> " +
        "</div> " +
        "</div> " +
        "<div class='modal-bg js-modal'></div>";

    $(popupTemplate).appendTo('body');
    $('#callback').addClass('open');
    $('.modal-bg').fadeIn().addClass('open');

    $('#personal-phone').mask("+7 (999) 999-99-99");

    var dataCookie = Cookies.getCookie('FILICITY_SM_utm_info');
    if(dataCookie)
    {
        dataCookie = JSON.parse(dataCookie);
        $('#name').val(dataCookie['firstname']);
    }

    $('#callback-form').validate({
        errorClass: "error",
        validClass: "success",
        errorElement: "em",
        focusInvalid: false,
        rules: {
            name: {
                required: true
            },
            phone: {
                required: true
            }
        },
        messages: {
            name: {
                required: ""
            },
            phone: {
                required: ""
            }
        },
        invalidHandler: function (event, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
            }
        },
        submitHandler: function() {
            var name = $("#name").val(),
                phone = $("#personal-phone").val();

            $.ajax({
                url: callbackformAPI,
                method: 'POST',
                data: {
                    name: name,
                    phone: phone
                },
                dataType: 'json',
                success: function (data) {
                    if (data.error) {
                        console.error(data);
                    } else {
                        $('.modal.open').removeClass('open');
                        $('#callback-success').addClass('open');
                    }
                },
                error: function (data) {
                    console.error(data);
                }
            });
        },
        highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);

        },
        unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
        },

        errorPlacement: function(error, element) {

        }
    });
}
function closePopup() {
    $('.modal.open').removeClass('open');
    $('.modal-bg').fadeOut().removeClass('open');
    $('.js-modal').remove();

}

$(document)
    .on('click', '.js-news-open', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        window.POPUP.openAjax(target);
    })
    .on('click', '.close-popup', function (e) {
        e.preventDefault();
        window.POPUP.close();
    })
    .on('click', '.js-popup-dom', function (e) {
        e.preventDefault();
        var link = $(this),
            target = link.attr('href');

        $.ajax({
            type: "POST",
            url: target,
            dataType: 'html',
            data: '',
            success: function (popup) {
                window.POPUP.openStatic(popup);
            }
        });
    })
    .on('click', '.js-zoom-img', function (e) {
        e.preventDefault();
        var target = $(this).attr('href'),
            number = parseInt($(this).data('slide-number'));
        window.POPUP.openImage(target, number);
    })
    .on('click', '.js-zoom-single', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        window.POPUP.imageSingle(target);
        return;
    })
    .on('click', '.js-video-popup', function (e) {
        e.preventDefault();
        var target = $(this).attr('href'),
            type = $(this).data('player');
        window.POPUP.openVideo(target, type);
    })
    .on('click', '.mfp-gallery-list__item', function (e) {
        e.preventDefault();

        var $this = $(this),
            $target = Number($this.attr('href'));

        if ($this.is('.current')) return;
        mfp.goTo($target);
    })
    .on('click', '.video-control', function (e) {
        e.preventDefault();
        var cursorFromLeft = e.pageX,
            boxWidth = $(this).outerWidth(true),
            percent = boxWidth / 100,
            boxFromLeft = $(this).offset().left,
            cursorPosition = cursorFromLeft - boxFromLeft,
            currentPercent = cursorPosition / percent;
        window.mediaPlayer[0].currentTime = window.mediaPlayer[0].duration * currentPercent / 100;
    })
    .on('click touchstart', '.mfp-player-item', function (e) {
        e.preventDefault();
        if (window.mediaPlayer[0].paused || window.mediaPlayer[0].ended) {
            window.mediaPlayer[0].play();
        } else {
            window.mediaPlayer[0].pause();
        }
    })
    .on('click touchstart', '.video-box__player', function (e) {
        e.preventDefault();

        var player = $(this);

        if (player[0].paused || player[0].ended) {
            player[0].play();
        } else {
            player[0].pause();
            player.parents('.js-video-native').find('.video-box__link').show();
        }
    })
    .on('click', '.js-video-vebcam', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        window.POPUP.webcamVideo(target);
    })
    .on('keypress change', '.form__input', function () {
        var $this = $(this),
            $val = $this.val();

        if ($val != '') {
            $this.addClass('completed');
        } else {
            $this.removeClass('completed');
        }
    })
    .on('click', '.js-order-call', function (e) {
        e.preventDefault();
        openCallback($(this));
    })
    .on('click', '.modal-bg', function (e) {
        e.preventDefault();
        closePopup();
    })
    .on('click', '.modal-close', function (e) {
        e.preventDefault();
        closePopup();
    })
    .on('click', '.js-housing-field', function (e) {
      var curLink = $(this).attr('data-link');
      window.location = curLink;
  })
    .on('keydown', function(eventObject){
    if (eventObject.which == 27)
        closePopup();
    });

$(".mobile-burger").on("click", function(){
    $(this).toggleClass("open");
});

$(function () {
    (function () {

        var $menu = $('.main-menu'),
            menuItemClass = 'main-menu__link',
            underMenuClass = 'under-menu',
            underMenuLinkClass = 'under-menu__link',
            openedClass = 'open',
            parent = $('#menu-visible'),
            speed = 200,
            timer;

        var menuItem = $menu.find('.' + menuItemClass);

        menuItem.map(function () {
            var thisItem = $(this),
                currentUnderMenu = thisItem.siblings('.' + underMenuClass);

            if (!currentUnderMenu.length) return;
                thisItem
                    .on('click', function (e) {
                        console.log(true);
                        var $this = $(this);

                        if ($this.siblings('.under-menu').length) {
                            e.preventDefault();

                            if ($('#menu-visible').is('.open')) {
                                //closeUnderMenu();
                            } else {
                                showUnderMenu(currentUnderMenu);

                                return;
                            }

                        }
                    })
                ;
            /*;} else {
                thisItem
                    .on('click', function (e) {
                        var $this = $(this);

                        if ($this.siblings('.under-menu').length) {
                            e.preventDefault();

                            if ($('#menu-visible').is('.open')) {
                                window.location.href = $this.attr('href');
                            } else {
                                showUnderMenu(currentUnderMenu);
                                return;
                            }

                        }
                    });
            } */
            $('.under-menu-close').on('click', function () {
                closeUnderMenu();
            });
            $('.under-menu-bg').on('click', function () {
                closeUnderMenu();
            });

            $('#tablet-burger').on('click', function () {
                $('.sidebar').removeClass('minimized');
            });


        });

        function leaveUnderMenu(link) {
            parent.on('mouseleave', function (e) {
                e.preventDefault();
                var relatedTarget = e.relatedTarget;

                if ($(relatedTarget)[0].text === link[0].text) return;

                closeUnderMenu();
                $('.under-menu-bg').removeClass(openedClass);
            });
        }

        function showUnderMenu(menu) {
            menu
                .clone(true, true)
                .appendTo(parent);

            parent
                .addClass(openedClass);

            $('.sidebar').addClass(openedClass);
            $('.under-menu-bg').addClass(openedClass);

            window.openSubmenu = true;

            setTimeout(function () {
                parent.find('.' + underMenuClass).addClass('push');
            }, 0);
        }

        function closeUnderMenu() {
            window.openSubmenu = false;

            parent
                .removeClass(openedClass);
            setTimeout(function () {
                parent.html('');
            }, speed);

            $('.sidebar').removeClass(openedClass);
            $('.under-menu-bg').removeClass(openedClass);
            parent.find('.' + underMenuClass).removeClass('push');
        }

        $(window)
            .scroll(function () {
                if (!$('.sidebar').is('.minimized')) {
                    $('.sidebar').addClass('minimized');
                    closeUnderMenu();
                }
            })
            .on('click', '.under-menu-bg', function () {
                if (!$('.sidebar').is('.minimized')) {
                    $('.sidebar').addClass('minimized');
                    closeUnderMenu();
                }
            })
        ;

    })();
});


// WEBPACK FOOTER //
// ./js/index.js